<template>
  <div style="height: inherit">
    <div
      class="body-content-overlay"
      :class="{ show: mqShallShowLeftSidebar }"
      @click="mqShallShowLeftSidebar = false"
    />

    <div class="email-app-list">
      <div class="app-fixed-search d-flex align-items-center">
        <div class="sidebar-toggle d-block d-lg-none ml-1">
          <feather-icon
            icon="MenuIcon"
            size="21"
            class="cursor-pointer"
            @click="mqShallShowLeftSidebar = true"
          />
        </div>
        <div class="d-flex align-items-center justify-content-between w-100">
          <b-input-group class="input-group-merge">
            <b-input-group-prepend is-text>
              <feather-icon icon="SearchIcon" class="text-muted" />
            </b-input-group-prepend>
            <b-form-input placeholder="جستجو ..." />
          </b-input-group>

          <div
            class="align-items-center mx-1"
            v-if="
              userData.permissions && userData.permissions.permissions.length
            "
          >
            <b-button
              class="py-50 px-50 w-100"
              variant="primary"
              block
              v-b-tooltip.hover.top="'ثبت همه پیام ها به عنوان خوانده شده'"
              @click="readAll"
            >
              <!-- <feather-icon
                icon="EyeIcon"
                size="17"
                class="cursor-pointer align-middle"
              /> -->
              <small style="white-space: nowrap"> مشاهده همه </small>
            </b-button>
          </div>
        </div>
      </div>

      <!-- Emails List -->
      <vue-perfect-scrollbar
        :settings="perfectScrollbarSettings"
        class="email-user-list scroll-area"
      >
        <b-row v-if="loading">
          <b-col v-for="item in 10" :key="item" cols="12" class="  ">
            <b-media class="py-1 border rounded mx-1 mt-1" no-body>
              <b-media-aside class="ml-2">
                <b-skeleton type="avatar"></b-skeleton>
              </b-media-aside>
              <b-media-body class="my-auto">
                <b-skeleton width="100px" height="15px" />
                <b-card-text class="font-small-3 mb-0">
                  <b-skeleton width="80px" height="15px" />
                </b-card-text>
              </b-media-body>
            </b-media>
          </b-col>
        </b-row>
        <ul class="email-media-list" v-else>
          <b-media
            v-for="(email, index) in emails"
            :key="index"
            tag="li"
            no-body
            :class="[
              'm-1 p-1 round',
              email.data.can_read && !email.data.read_at && 'bg-unread',
            ]"
            @click="readEmail(email.data)"
          >
            <b-media-aside class="media-left align-self-center">
              <b-avatar
                class="avatar"
                :src="email.data.notifiable.avatar"
                size="70 "
                variant="primary"
                rounded="sm"
              />
              <!-- <div class="user-action">
             
                <b-form-checkbox @click.native.stop />
              </div> -->
            </b-media-aside>

            <b-media-body>
              <div class="mail-details mb-0 d-flex">
                <div class="mail-items">
                  <h5 class="mb-25">
                    {{ email.data.data.sender_name }}
                  </h5>
                  <span class="text-truncate">{{
                    email.data.data.subject
                  }}</span>
                  <div
                    v-if="
                      userData.permissions &&
                      userData.permissions.permissions.length
                    "
                  >
                    <hr class="mb-1 mt-1" v-if="email.allSend > 1" />
                    <small class="mr-50 mb-50" v-if="email.allSend > 1">
                      ارسال شده :

                      <b-badge class="pt-50" variant="primary">
                        {{ email.allSend }}
                      </b-badge>
                    </small>
                    <!-- <br/> -->
                    <small v-if="email.allSend > 1">
                      خوانده شده :

                      <b-badge class="pt-50" variant="primary">
                        {{ email.allSend }}
                      </b-badge>
                    </small>
                  </div>
                </div>
                <div
                  class="d-flex flex-column align-items-center justify-content-center"
                >
                  <div class="mb-50" style="text-align: center">
                    <span class="mail-date">{{
                      calcDate(email.data.created_at)
                    }}</span>
                  </div>
                  <b-button
                    variant="primary"
                    size="sm"
                    v-if="email.data.can_read && !email.data.read_at"
                  >
                    مشاهده
                  </b-button>
                </div>
              </div>

              <!-- <div class="mail-message">
                <p
                  class="text-truncate mb-0"
                  v-html="
                    Array.isArray(email.data.content[0])
                      ? ''
                      : email.data.content
                  "
                ></p>
              </div> -->
            </b-media-body>
          </b-media>
        </ul>
        <div class="no-results" :class="{ show: !emails.length }">
          <h5>پیامی یافت نشد</h5>
        </div>
      </vue-perfect-scrollbar>
      <div class="app-action">
        <!-- <div class="action-left d-flex align-items-center">
        
          <b-form-checkbox> انتخاب همه </b-form-checkbox>
        </div> -->
        <b-pagination
          v-if="!showEmailDetails"
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          size="md"
          class="mb-0 mx-auto"
        ></b-pagination>
      </div>
    </div>

    <email-view
      v-if="Object.keys(emailViewData).length"
      :class="{ show: showEmailDetails }"
      :email-view-data="emailViewData"
      @close-email-view="showEmailDetails = false"
    />

    <portal to="content-renderer-sidebar-left">
      <email-left-sidebar
        :shall-show-email-compose-modal.sync="shallShowEmailComposeModal"
        :class="{ show: mqShallShowLeftSidebar }"
        @close-left-sidebar="mqShallShowLeftSidebar = false"
      />
    </portal>

    <email-compose
      v-model="shallShowEmailComposeModal"
      v-if="userData.permissions && userData.permissions.permissions.length"
    />
  </div>
</template>

<script>
import {
  BButton,
  BRow,
  BCol,
  BSkeleton,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BMedia,
  BMediaAside,
  BMediaBody,
  BAvatar,
  BPagination,
  VBTooltip,
  BCardText,
  BBadge,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import EmailLeftSidebar from "./EmailLeftSidebar.vue";
import EmailView from "./EmailView.vue";
import qs from "qs";

import EmailCompose from "./EmailCompose.vue";

export default {
  components: {
    BButton,
    BBadge,
    BSkeleton,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
    BMedia,
    BMediaAside,
    BMediaBody,
    BAvatar,
    BPagination,
    VuePerfectScrollbar,
    EmailLeftSidebar,
    EmailView,
    EmailCompose,
    BCardText,
    BRow,
    BCol,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      emails: [],
      count: 0,
      pagination: {},
      currentPage: 1,
      loading: false,
      allSend: 0,
      seenCound: 0,
      shallShowEmailComposeModal: false,
      showEmailDetails: false,
      mqShallShowLeftSidebar: false,
      perfectScrollbarSettings: {
        maxScrollbarLength: 150,
      },
    };
  },

  computed: {
    emailViewData() {
      return this.$store.state.appConfig.emailViewData;
    },
    userData() {
      return this.$store.state.auth.userData || {};
    },
  },
  watch: {
    emailViewData(val) {
      if (Object.keys(val).length) {
        this.showEmailDetails = true;
      }
    },
    $route: {
      handler(val) {
        this.currentPage = val.query.page;
        this.getNotifications();
      },
      immediate: true,
      deep: true,
    },
    currentPage(val) {
      if (val != this.$route.query.page) {
        this.$router.push({
          name: "apps-email",
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
  },
  methods: {
    async readAll() {
      try {
        const { data } = await this.$http.put(`/panel/notifications/read-all`);
        await this.getNotifications();
        await this.getCount();
      } catch (err) {}
    },
    async getCount() {
      const { data } = await this.$http.get("/panel/notifications/count");
      this.$store.dispatch("appConfig/getNotifCount", data.data.count);
    },
    async getNotifications() {
      try {
        this.loading = true;
        let filters = {};
        if (this.$route.path.includes("is_system")) {
          filters.is_system = 1;
        } else if (this.$route.path.includes("isnot_system")) {
          filters.is_system = 0;
        } else {
          filters = {};
        }
        const params = {
          per_page: 8,
          ...this.$route.query,
          filters,
        };
        const { data } = await this.$http.get("/panel/notifications", {
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        if (
          this.userData.permissions &&
          this.userData.permissions.permissions.length
        ) {
          this.emails = data.data.notifications.map((item) => {
            return {
              data: item[0],
              seenCound: item.filter((item) => item.read_at).length,
              allSend: item.length,
            };
          });
        } else {
          this.emails = data.data.notifications.map((item) => {
            return {
              data: item,
            };
          });
        }

        this.pagination = data.data.meta.pagination;
      } catch (err) {}

      this.loading = false;
    },
    async readEmail(email) {
      try {
        if (
          !email.read_at &&
          email.can_read &&
          this.userData.permissions &&
          !this.userData.permissions.permissions.length
        ) {
          const { data } = await this.$http.patch(
            `/panel/notifications/${email.id}/read`
          );
          await this.getNotifications();
          await this.getCount();
        }
        this.showEmailDetails = true;
        this.$store.dispatch("appConfig/getEmailViewData", email);
      } catch (err) {}
    },
  },
  created() {
    if (Object.keys(this.emailViewData).length) {
      this.readEmail(this.emailViewData);
    }
  },
  async beforeCreate() {
    await this.$router
      .push({
        name: "apps-email",
        query: {
          ...this.$route.query,
          page: 1,
        },
      })
      .catch((err) => {});
    // this.getNotifications();
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="scss">
@import "~@core/scss/base/pages/app-email.scss";
</style>
